import axios from 'axios';
import { Insurance } from '../models';

export const getInsurancesAsync = async (): Promise<Insurance[]> => {
    const response = await axios.get(`/api/patient-insurance`);
    return response.data;
};

export const getInsuranceCopay = async (): Promise<Undefinable<number>> => {
    const response = await axios.get(`/api/patient-insurance/copay`);
    return response.data;
};
